import { GridWithGaps, Text_32_48 } from '@dreamstack/feature-components'
import type { BlockStockPriceFragment } from '@dreamstack/investors-graphql'
import type { FunctionComponent } from 'react'
import tw from 'twin.macro'
import { StockPriceSectionCustom } from './StockPriceSectionCustom'
import { StockPriceSectionIframe } from './StockPriceSectionIframe'

const Paragraph = tw.div`col-span-12 md:(col-span-7 col-start-1) lg:(col-span-8) whitespace-pre-line`
const StockColumn = tw.div`col-span-12 md:(col-span-5 col-start-8) lg:(col-span-4 col-start-9 justify-self-end)`

const SHOW_CUSTOM_STOCK = false

export const StockPriceSection: FunctionComponent<React.PropsWithChildren<{
  block: BlockStockPriceFragment
}>> = ({ block }) => {
  return (
    <GridWithGaps tw="gap-y-px-64">
      <Paragraph>
        <Text_32_48>{block.stockPriceDescription}</Text_32_48>
      </Paragraph>
      <StockColumn>
        {SHOW_CUSTOM_STOCK ? (
          <StockPriceSectionCustom />
        ) : (
          <StockPriceSectionIframe />
        )}
      </StockColumn>
    </GridWithGaps>
  )
}
